function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from "react";
import { node } from "prop-types";
import classNamesMaker from "classnames";
import { useInView } from "react-intersection-observer";
import { useMenuBar } from "#library/components/MenuBar/MenuBarContext";
import styles from "#library/components/MenuBar/menuBar.module.css";
var MARGIN_RIGHT = 20;
export var MenuBarItem = function MenuBarItem(_ref) {
  var children = _ref.children;
  var _useMenuBar = useMenuBar(),
    parentRef = _useMenuBar.parentRef,
    marginWidth = _useMenuBar.marginWidth;
  var _useInView = useInView({
      /* Number between 0 and 1 indicating the percentage current Element should be visible before triggering. */
      threshold: 1,
      /* Identify the Element whose bounds are treated as the bounding box of the viewport for the element which is the observer's target. */
      root: parentRef,
      rootMargin: "0px -".concat(marginWidth + MARGIN_RIGHT, "px 0px 0px")
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var itemClassNames = classNamesMaker(styles["jds-MenuBar__item"], !inView && styles["jds-MenuBar__item--noVisible"]);
  return /*#__PURE__*/React.createElement("li", {
    ref: ref,
    className: itemClassNames
  }, children);
};
MenuBarItem.propTypes = {
  children: node.isRequired
};